import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import RankingSalesReport from "../../../containers/modules/report/ranking-sales-report";

export default function RankingSalesRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="ranking-sales"
      index
      element={
        <AccessControl
          name={"Report Ranking Sales"}
          auth={authUser}
          component={() => <RankingSalesReport />}
        />
      }
    ></Route>
  );
}
